import React, { useEffect, useState } from 'react'
import { PDFGenerated } from './PDFGenerated'
import { useSelector } from 'react-redux';
import { PDFViewer } from '@react-pdf/renderer';

export const ModalCommisions = () => {
    const { isLoading, orders, dateStart, dateEnd, rows, msg } = useSelector(state => state.reportsFinance);
    const { usuario} = useSelector(state => state.usuario);


    const [pdfKey, setPdfKey] = useState(0);
    const [mostrarPDF, setMostrarPDF] = useState(false);
    const closeModal = () => {
        // dispatch(clearStoreCashOutDetail());
        setMostrarPDF(false); // limpia si se cierra el modal
    }


    const generarPDF = () => {
        setMostrarPDF(false);
        setTimeout(() => {
            setPdfKey(prev => prev + 1);
            setMostrarPDF(true);
        }, 100);
    };

    useEffect(() => {
        // Escucha el evento desde Layout
        const handleGenerate = () => generarPDF();
        document.addEventListener('generatePdfCommisions', handleGenerate);
        return () => document.removeEventListener('generatePdfCommisions', handleGenerate);
    }, []);


    return (
        <div className="modal fade" id="detailPDFCommisions" data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-xl">
                <div className="modal-content">
                    <div className="modal-header">
                        <h1 className="modal-title fs-5 fw-bold" id="exampleModalLabel">Vista previa...</h1>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={closeModal}></button>
                    </div>

                    <div className="modal-body row pdfViewer">

                        {
                            (mostrarPDF) && (
                                <PDFViewer key={pdfKey} >
                                    <PDFGenerated userName={usuario} data={orders} rows={rows} />
                                </PDFViewer>
                            )
                        }
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-outline-dark" data-bs-dismiss="modal" onClick={closeModal}>Cerrar</button>
                    </div>
                </div>
            </div>
        </div>
    )
}
